interface PacmanSpinnerProps {
  width?: number
  height?: number
}

export const PacmanSpinner = ({ width = 70, height = 70 }: PacmanSpinnerProps) => {
  return (
    <svg
      style={{ margin: 'auto', background: 'none', display: 'block', shapeRendering: 'auto' }}
      width={width}
      height={height}
      viewBox='0 0 100 100'
      preserveAspectRatio='xMidYMid'
    >
      <style>{`
        @keyframes pacman-top {
          0%, 100% { transform: rotate(0deg); }
          50%       { transform: rotate(45deg); }
        }
        @keyframes pacman-bottom {
          0%, 100% { transform: rotate(0deg); }
          50%       { transform: rotate(-45deg); }
        }
        @keyframes pacman-dot-move {
          from { transform: translateX(0); }
          to   { transform: translateX(-60%); }
        }
        @keyframes pacman-dot-fade {
          0%   { opacity: 0; }
          20%  { opacity: 1; }
          100% { opacity: 1; }
        }
      `}</style>

      {/* Three dots — translateX(-60%) with transform-box:view-box == 60 SVG user units */}
      {['-0.67s', '-0.33s', '0s'].map((delay, i) => (
        <g
          key={i}
          style={{
            transformBox: 'view-box',
            animation: `pacman-dot-move 1s linear ${delay} infinite`,
          }}
        >
          <circle
            cx='95'
            cy='50'
            r='4'
            fill='#ffe279'
            style={{ animation: `pacman-dot-fade 1s linear ${delay} infinite` }}
          />
        </g>
      ))}

      {/* Static right-side body (rotated upper semicircle) */}
      <path d='M35 50L5 50A30 30 0 0 0 65 50Z' fill='#7669ff' transform='rotate(90 35 50)' />

      {/* Top jaw — rotates +45° (opens upward) around (35,50) */}
      <path
        d='M35 50L5 50A30 30 0 0 0 65 50Z'
        fill='#7669ff'
        style={{
          transformBox: 'view-box',
          transformOrigin: '35% 50%',
          animation: 'pacman-top 1s linear infinite',
        }}
      />

      {/* Bottom jaw — rotates -45° (opens downward) around (35,50) */}
      <path
        d='M35 50L5 50A30 30 0 0 1 65 50Z'
        fill='#7669ff'
        style={{
          transformBox: 'view-box',
          transformOrigin: '35% 50%',
          animation: 'pacman-bottom 1s linear infinite',
        }}
      />
    </svg>
  )
}
